import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/trendelantero/masa2.png")